<template>
  <section>
    <div class="form-group mb-2">
      <div :class="{ 'form-group row': inline }">
        <div :class="inlineLabelClass">
          <label v-if="label" :for="name" class="control-label">
            {{ label }}:
            <span class="text-danger" v-if="hasAsterisk">*</span>
          </label>
        </div>
        <div :class="inlineInputClass">
          <input
            :id="name"
            class="form-control"
            :class="addClass"
            :style="addStyle"
            :type="type || 'text'"
            :name="name"
            :value="inputValue"
            :min="min"
            :max="max"
            :step="step"
            :maxlength="maxlength || 200"
            :placeholder="placeholder || label"
            :disabled="disabled"
            :readonly="readonly"
            :tabindex="tabindex"
            :autocomplete="autocomplete"
            @input="change"
            @keyup="keyup"
            @blur="blur"
          />
        </div>
        <small v-if="$page.props.errors[name]" class="text-danger">
          {{ $page.props.errors[name][0] }}
        </small>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'z-Input',
  props: {
    name: String,
    type: String,
    modelValue: [Number, String, Boolean, Date],
    label: String,
    validate: String,
    disabled: Boolean,
    maxlength: Number,
    placeholder: String,
    autocomplete: String,
    min: String,
    max: String,
    step: String,
    addClass: String,
    addStyle: String,
    readonly: Boolean,
    inline: {
      type: Boolean,
      default: false,
    },
    inlineSize: {
      type: Number,
      default: 10,
    },
    tabindex: [Number, String],
  },
  emits: ['keyup', 'blur', 'update:modelValue'],
  computed: {
    inputValue() {
      return this.modelValue
    },
    hasAsterisk() {
      return this.validate && this.validate.includes('required')
    },
    inlineLabelClass() {
      let _data = ''
      if (this.inline) {
        _data = 'col-sm-2 mt-1'
        if (this.inlineSize <= 10) {
          _data = `col-sm-${12 - this.inlineSize} mt-1`
        }
      }
      return _data
    },
    inlineInputClass() {
      let _data = ''
      if (this.inline) {
        _data = 'col-sm-10'
        if (this.inlineSize <= 10) {
          _data = `col-sm-${this.inlineSize}`
        }
      }
      return _data
    },
  },
  methods: {
    change($event) {
      this.$emit('update:modelValue', $event.target.value)
    },
    keyup($event) {
      this.$emit('keyup', $event.target.value)
    },
    blur($event) {
      this.$emit('blur', $event.target.value)
    },
  },
}
</script>
